import { Helmet } from 'react-helmet-async';

import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// @mui
import { Paper, Container, Typography, Grid, CircularProgress, Box } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PropTypes from 'prop-types';

import { GetCompany } from 'src/components/services/httpServices';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function CompanyDetails() {
  let { id } = useParams();
  const navigate = useNavigate();
  const [company, setCompany] = useState({});
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('sdsdsdsds');

  const fetchCompany = async (event) => {
    const company = await GetCompany(id);
    setCompany(company);
    setLoading(false);
  };
  useEffect(() => {
    fetchCompany();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  // console.log('company', company);

  return (
    <>
      <Helmet>
        <title> Employer | Immigration System </title>
      </Helmet>
      <Container>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <>
            <Box
              p={4}
              marginBottom={4}
              component={Paper}
              boxShadow={3}
              sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
            >
              <Grid container spacing={3}>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Full Name :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {company?.companyName}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Company GST :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {company?.companyGst}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Business Type :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {company?.businessInformations[0]?.businessType}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Business Address :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {company?.companyContactInformations[0]?.businessAddress}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Mailing Address :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {company?.companyContactInformations[0]?.mailingAddress}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Business Phone Number :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {company?.companyContactInformations[0]?.businessPhoneNumber}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Email Address :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {company?.companyContactInformations[0]?.employerEmailAddress}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Company Website :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {company?.companyContactInformations[0]?.companyWebsite}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </>
        )}
      </Container>
      {saved ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
